import * as React from "react";
import clsx from "clsx";
import { UseFormRegister, FieldErrors } from "react-hook-form";
import { StyledText } from "../../../assets/typography/typography";
import { colors } from "../../../components/colors";

interface OwnProps {
  name: string;
  label: string;
  helpText?: string;
  defaultValue?: string | number | string[] | undefined;
  register: UseFormRegister<any>;
  errors: FieldErrors<any>;
  rows?: number;
}

export const TextareaFormField: React.FC<OwnProps> = (props) => {
  const errors = props.errors;
  const hasError = !!errors?.[props.name];
  const errorMessage = errors?.[props.name]?.message as string;

  return (
    <div
      className={clsx({
        "form-group w-100": true,
        "has-error w-100": hasError,
      })}
    >
      {props.label && (
        <StyledText
          color={colors.textPrimary}
          className="bodySubtextSemibold mb-2"
        >
          {props.label}
        </StyledText>
      )}
      <textarea
        className="form-control"
        {...props.register(props.name as any)}
        defaultValue={props.defaultValue}
        rows={props.rows || 5}
        data-test-form-field={props.name}
      ></textarea>
      {hasError && (
        <StyledText
          color={colors.errorDark}
          className="bodySubtextRegular mt-2"
        >
          {errorMessage}
        </StyledText>
      )}
      {props.helpText && (
        <StyledText
          color={colors.textSecondary}
          className="bodySubtextRegular mt-2"
        >
          {props.helpText}
        </StyledText>
      )}
    </div>
  );
};
